import React from 'react'
import NavAdmin from '../Components/AdminNav/NavAdmin'
import GetAbout from '../Components/GetAboutUs/GetAbout'

function GetAboutUs() {
  return (
    <div>
        <NavAdmin />
        <GetAbout />
    </div>
  )
}

export default GetAboutUs